import { Type } from '@angular/core';
import { InventoryEffects } from './inventory';
import { AppEffects } from './app/app.effects';
import { SettingsOptionsEffects } from './settings-options/settings-options.effects';
import { HiveEffects } from './hive';
import { ApiaryEffects } from './apiary';
import { LoggingEffects } from './logs';
import { ApplicationsEffects } from './applications';
import { LotEffects } from './lots';
import { UserProfileEffects } from './user-profile';
import { NoteEffects } from './notes/note.effects';
import { DocumentsEffects } from './documents/documents.effects';
import { SessionEffects } from './session/session.effects';

export const effects: Type<any>[] = [

  // Inventory excluded for now
  // InventoryEffects,

  AppEffects,
  SettingsOptionsEffects,
  HiveEffects,
  ApiaryEffects,
  LoggingEffects,
  ApplicationsEffects,
  LotEffects,

  UserProfileEffects,
  NoteEffects,
  DocumentsEffects,
  SessionEffects
];
